module.exports = __webpack_public_path__ + "img/banner.3fdc3117.png";